import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const callAmPl = (url, retry = 0) => {
    if (typeof window.AM_PL === "function") {
      window.AM_PL(url);
      return;
    }

    if (retry < 20) {
      setTimeout(() => callAmPl(url, retry + 1), 300);
    }
};

export default function ScrollToTop(){
    const { pathname, search } = useLocation();
    const firstRun = useRef(true);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
      if (firstRun.current) {
        firstRun.current = false;
        return;
      }

      callAmPl(window.location.href);
    }, [pathname, search]);

    return null;
}
